/**
 * https://github.com/mui/material-ui/blob/master/examples/joy-ui-nextjs-ts/src/components/ThemeRegistry/ThemeRegistry.tsx
 * https://mui.com/joy-ui/react-css-baseline/#cssbaseline
 */

'use client';
import CssVariableProvider from '@unifyapps/style/joy/CssVariableProvider';
import type * as React from 'react';
import NextAppDirEmotionCacheProvider from './EmotionCache';
import theme from './theme';

/**
 * https://github.com/mui/material-ui/issues/24109#issuecomment-1059079717 for prepend: true
 * https://mui.com/material-ui/guides/interoperability/#tailwind-css
 */
const OPTIONS = { key: 'joy', prepend: true };

export default function ThemeRegistry({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <NextAppDirEmotionCacheProvider options={OPTIONS}>
      <CssVariableProvider theme={theme}>{children}</CssVariableProvider>
    </NextAppDirEmotionCacheProvider>
  );
}
